import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import PropTypes from "prop-types";
import ModalContentWrapper from '../ModalContentWrapper';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import {getUserConnections2, getUserDetails, getUserRelationAndPermission} from "root/DataFunctions/UserDataFns";
import {createUserRoles, updateUserRoles} from "root/DataFunctions/UserDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {FamilyMemberGroup, UserGroupTypes, UserRoleGroups, UserTypes} from "root/DataFunctions/Constants";
import {countNumberOfEditors} from "root/DataFunctions/ChildDataFns";
//import bootbox from "bootbox";
import {useForm} from "react-hook-form";
import FormToggle from "root/ReactHookForm/ControlWrappers/FomToggle";
import ErrorDiv from "root/ReactHookForm/ui/ErrorDiv";
import DropdownUserConnections from "root/ReactHookForm/ui/DropdownUserConnections";
import DropdownUserRelationTypes from "root/ReactHookForm/ui/DropdownUserRelationTypes";
import DropdownFamilyTypes from "root/ReactHookForm/ui/DropdownFamilyTypes";
import DropdownMyContributors from "root/ReactHookForm/ui/DropdownMyContributors";
import phpVars from 'phpVars';

const SaveButton = ({state, onClick, label}) =>
{
    const clickHandler = state === '' ? onClick : null;

    return (
        <button onClick={clickHandler} style={{marginRight: '10px', marginLeft: '10px'}} disabled={state}
                className='btn btn-icon btn-primary btn-icon-right btn-small'>{label}<i className="et-save"/>
        </button>
    )
}

const ModalAddUserConnection = (props) =>
{
    //State management
    const [buttonState, setButtonState] = useState('');
    const [data, setData] = useState({isLoading: true, data: []});
    const [fromUserName, setFromUserName] = useState('');
    const [fromUserType, setFromUserType] = useState(0);
    const [connectedUserDetails, setConnectedUserDetails] = useState ( null ) ;
    const [wasEditor, setWasEditor] = useState ( null ) ;
    const [numberOfEditors, setNumberOfEditors] = useState ( null ) ;

    const {register, control, handleSubmit, setFocus, watch, setValue, formState: {errors: formErrors}} = useForm(
        {
            defaultValues: {
                contact:
                    {
                        is_messager: false,
                        is_contributor: false,
                        is_manager: false,
                        is_editor: false,
                    },
                contact_plan:
                    {
                        is_mailer: false,
                        has_contact_plan: false,
                        is_letterbox_required: false,
                    },
                user: {
                    relation_notes: null,
                    ur_relation_type: {value: undefined, ur_relation_type: 0},
                    ur_family_type_id: {value: undefined, ur_family_type_id: 0},
                    connected_user: {value: undefined, userTypeId: 0},
                    known_as: null,
                }
            }
        });

    const connectedUser = watch('user.connected_user');
    const hasContactPlan = watch('contact_plan.has_contact_plan')

    useEffect(() =>
    {
        if (props.mode === 'edit')
        {
            //Get the users name first
            getUserDetailsAndRights();

            //Get the number of editors
            getNumberOfEditors();

            getUserRelationAndPermission(props.user_id, props.from_user_id, (response) =>
            {
                const userRolesData = getDataFromResponse(response)[0];
                userRolesData.has_contact_plan = +userRolesData.has_contact_plan !== 0;
                const permissions = userRolesData.permissions;
                const familyTypeValue = userRolesData.ur_family_type_id === null ? undefined : {value: +(userRolesData.ur_family_type_id)};

                setValue('contact', {
                        is_messager: permissions.is_messager,
                        is_contributor: permissions.is_contributor,
                        is_manager: permissions.is_manager,
                        is_editor: permissions.is_editor,
                    }
                );

                setValue('contact_plan', {
                        is_letterbox_required: permissions.is_letterbox_required,
                        has_contact_plan: userRolesData.has_contact_plan,
                        is_mailer: permissions.is_mailer,
                    }
                );

                setValue('user', {
                        relation_notes: userRolesData.relation_notes,
                        known_as: userRolesData.known_as,
                        connected_user: {value: props.user_id_raw, userTypeId: permissions.userTypeId},
                        ur_family_type_id: familyTypeValue,
                        ur_relation_type: {value: +(userRolesData.ur_relation_type)},
                    }
                );

                setWasEditor(permissions.is_editor);
                setData({isLoading: false, data: userRolesData});
            });
        }
        else
        {
            getUserDetails(props.from_user_id, null, (response) =>
            {
                const userData = getDataFromResponse(response)[0];

                setValue('user', {
                        relation_notes: null,
                        connected_user: {value: undefined, userTypeId: 0},
                        known_as: '',
                        ur_family_type_id: undefined,
                        ur_relation_type: undefined }
                );

                setValue('contact_plan', {
                        is_mailer: false,
                        is_letterbox_required: false,
                        has_contact_plan: false
                    }
                );

                setValue('contact', {
                        is_messager: false,
                        is_contributor: false,
                        is_manager: false,
                        is_editor: false,
                    }
                );

                doSetUserName(userData);
                setFromUserType(+(userData.userTypeId));

                // We need to set this state last so the isLoading will trigger the first render.
                setData({isLoading: false, data: userData});
            });
        }

    }, [props.user_id]);

    useEffect(() =>
    {
        if ( props.mode === 'create')
        {
            const connected_user_uid = connectedUser.value !== undefined ? connectedUser.value : null;

            //Check if the user you are connecting to is a manager or edititor
            if ( connected_user_uid !== null )
            {
                getConnectedUserDetails(connected_user_uid);
            }
        }
    }, [connectedUser]);

    const getUserDetailsAndRights = () =>
    {
        getUserDetails(props.from_user_id, null, (response) =>
        {
            const userData = getDataFromResponse(response)[0];
            doSetUserName(userData)
            setFromUserType(+(userData.userTypeId));
        });
    }

    const doSetUserName = (userData) =>
    {
        //Check logged in user type staff see birth name parents see adopted name if they have one
        const loggedOnUserIsStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF;
        const hasAdoptedName = userData.adopted_firstname != null && userData.adopted_firstname != '' && userData.adopted_firstname != undefined ? true : false;
        const name = !loggedOnUserIsStaff && hasAdoptedName ? userData.adopted_firstname : userData.firstname + ' ' + userData.surname;

        setFromUserName(name);
    }

    const getDefaultKnownAsForUserType = ( fromUserType, toUserType, data ) =>
    {
        if ( fromUserType === UserTypes.CHILD )
        {
            // If we are connecting to a child, the known as name depends on the type of user we are connecting
            switch ( toUserType )
            {
                case UserTypes.CHILD:
                case UserTypes.BIRTH_PARENT:
                case UserTypes.OTHER:
                    if ( data.data.description !== null  && data.data.description !== '')
                    {
                        return data.data.description;
                    }
                    else{
                        return data.data.firstname
                    }

                case UserTypes.FOSTER_PARENT:
                    return data.data.firstname  ;

                case UserTypes.FOREVER_PARENT:
                    if ( data.data.adopted_firstname === null || data.data.adopted_firstname === '')
                    {
                        return data.data.firstname  ;
                    }
                    else {
                        return data.data.adopted_firstname  ;
                    }

                case UserTypes.LIFE_STORY_WORKER:
                case UserTypes.ORG_MANAGER:
                case UserTypes.ORG_STAFF:
                    if ( data.data.adopted_firstname === null || data.data.adopted_firstname === '')
                    {
                        return data.data.firstname + ' ' + data.data.surname ;
                    }
                    else {
                        return data.data.adopted_firstname + ' ' + data.data.adopted_surname ; ;
                    }

                default:
                    return data.data.firstname + ' ' + data.data.surname ;
            }
        }
        else if ( fromUserType === UserTypes.FOREVER_PARENT || fromUserType === UserTypes.FOSTER_PARENT )
        {
            switch ( toUserType )
            {
                case UserTypes.BIRTH_PARENT:
                case UserTypes.OTHER:
                    return data.data.firstname;

                case UserTypes.CHILD:
                    if ( data.data.description !== null  && data.data.description !== '')
                    {
                        return data.data.description;
                    }
                    else{
                        return data.data.firstname
                    }

                default:
                    return data.data.firstname + ' ' + data.data.surname ;
            }
        }
        else if ( fromUserType === UserTypes.BIRTH_PARENT || fromUserType === UserTypes.OTHER )
        {
            switch ( toUserType )
            {
                case UserTypes.CHILD:
                    if ( data.data.description !== null  && data.data.description !== '')
                    {
                        return data.data.description;
                    }
                    else{
                        return data.data.firstname
                    }

                default:
                    return data.data.firstname + ' ' + data.data.surname ;
            }
        }
        else{
            return data.data.firstname + ' ' + data.data.surname ;
        }
    }

    const getConnectedUserDetails = (user_id) =>
    {
        getUserDetails(user_id, null, (response) =>
        {
            const userData = getDataFromResponse(response)[0];
            const toUserType = +(userData.userTypeId) ;
            const knownAsName = getDefaultKnownAsForUserType ( fromUserType, toUserType, data ) ;

            setConnectedUserDetails( userData ) ;
            setValue('user.known_as', knownAsName);
        });
    }

    const getNumberOfEditors = () =>
    {
        getUserConnections2(props.from_user_id, (conResponse) =>
        {
            const connectionRecs = getDataFromResponse(conResponse);
            const numberOfEditors = countNumberOfEditors(connectionRecs);
            setNumberOfEditors(numberOfEditors);
        });
    }

    const onSaveComplete = () =>
    {
        props.onSaveCompleted('saved');
        props.onClose();
    }

    const onClickCancel = () =>
    {
        props.onClose();
    }

    const doSaveNew = (data, onSaveComplete) =>
    {
        const to_user_id = data.user.connected_user.idusers;
        const toFromIsOrgStaff = UserRoleGroups.CAN_BE_STAFF.includes(+connectedUser.userTypeId) || UserRoleGroups.CAN_BE_STAFF.includes(fromUserType) ? true : false;

        //LIF-1267 Check if the user is creating a direct messaging connection (no letterbox) between two adults (but not org staff) and ask for confirmaton
        if (!data.contact_plan.is_letterbox_required && data.contact.is_messager && fromUserType !== UserTypes.CHILD && +connectedUser.userTypeId !== UserTypes.CHILD && !toFromIsOrgStaff)
        {
            bootbox.confirm({
                message: "You are creating a direct messaging connection (no letterbox).<br>Please confirm you want to do this?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: 'No',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result)
                    {
                        createUserRoles(props.from_user_id, to_user_id, data, onSaveComplete);
                    }
                    else
                    {
                        onSaveComplete();
                    }
                }
            });
        }
        else
        {
            createUserRoles(props.from_user_id, to_user_id, data, onSaveComplete);
        }

    }

    const doSave = (data, onSaveComplete) =>
    {
        data.contact_plan_override = hasContactPlan ;

        //Make sure if user has switched contact plan off letters and letterbox are switched off.
        if(!data.contact_plan.has_contact_plan)
        {
            data.contact_plan.is_letterbox_required = false;
            data.contact_plan.is_mailer = false;
        }

        //Check if we have removed the last editor for this child
        const editorRemoved = !!(wasEditor && !data.contact.is_editor);
        const toFromIsOrgStaff = UserRoleGroups.CAN_BE_STAFF.includes(+connectedUser.userTypeId) || UserRoleGroups.CAN_BE_STAFF.includes(fromUserType);

        if(editorRemoved && numberOfEditors === 1){
            bootbox.alert({
                size: "large",
                title: "Error",
                message: "You are attempting to remove this child's only editor. You need to add another editor before removing this one.",
                callback: function ()
                {
                    onSaveComplete();
                }
            })
        }
        else
        {
            //LIF-1267 Check if the user is creating a direct messaging connection (no letterbox) between two adults and ask for confirmaton
            if (!data.contact_plan.is_letterbox_required && data.contact.is_messager && fromUserType !== UserTypes.CHILD && +connectedUser.userTypeId !== UserTypes.CHILD && !toFromIsOrgStaff)
            {
                bootbox.confirm({
                    message: "You are creating a direct messaging connection (no letterbox).<br>Please confirm you want to do this?",
                    buttons: {
                        confirm: {
                            label: 'Yes',
                            className: 'btn-success'
                        },
                        cancel: {
                            label: 'No',
                            className: 'btn-danger'
                        }
                    },
                    callback: function (result) {
                        if (result)
                        {
                            updateUserRoles(props.from_user_id, props.user_id, data, onSaveComplete);
                        }
                        else
                        {
                            onSaveComplete();
                        }
                    }
                });
            }
            else
            {
                updateUserRoles(props.from_user_id, props.user_id, data, onSaveComplete);
            }
        }
    }

    const disableButtons = () =>
    {
        setButtonState('disabled');
    }

    const enableButtons = () =>
    {
        setButtonState('');
    }

    const getSaveButtonText = () =>
    {
        const saveButtonText = {
            edit: 'Save Changes',
            create: 'Save',
        };

        return saveButtonText[props.mode];
    }

    const onSubmit = (data) =>
    {
        disableButtons();

        switch (props.mode)
        {
            case 'create' :
                doSaveNew(data, onSaveComplete);
                break;
            case 'edit' :
                doSave(data, onSaveComplete);
                break;
        }
    }

    const onClickSaveForm = (status) =>
    {
        handleSubmit(onSubmit)(status);
    }

    const validateDropdown = (val) =>
    {
        if (val.value === undefined)
        {
            return "You must select a value";
        }
    }

    const getKnownAsLabel = () =>
    {
        let label = '' ;

        if ( props.mode === 'create' )
        {
            if ( connectedUserDetails === null )
            {
                label = "Known as";
            }
            else
            {
                label = fromUserName + " is known to " + connectedUserDetails.firstname + " as " ;
            }
        }
        else
        {
            label = fromUserName + " is known to " + data.data.to_firstname + " as" ;
        }

        return label ;
    }

    const title = () =>
    {
        const headerStyle = {marginBottom: '10px'};

        switch (props.mode)
        {
            case 'edit':
                return <h3 style={headerStyle}>{'Edit ' + fromUserName + "'s connection to"}</h3>
            case 'create':
                return <h3 style={headerStyle}>{'Connect ' + fromUserName + ' to'}</h3>
        }
    }

    const formContent = () =>
    {
        if (data.isLoading === true)
        {
            return (
                <div style={{width: props.width}}>
                    <SpinnerDiv/>
                </div>
            )
        }
        else
        {
            // From dropdown
            const connectionUserType = +connectedUser.userTypeId;
            const dropdownIsReadOnly = props.mode !== 'create';
            const knownAsLabel = getKnownAsLabel() ;

            // Logic to show/hide role toggles - Note these need to be discussed with Neil and could be replaced when the contact plan is ready
            //If from and to user are both adults we only want to show the 'message' toggle;
            const bothAreAdults = connectionUserType !== UserTypes.CHILD && fromUserType !== UserTypes.CHILD;
            const genericRelationshipType = connectionUserType === UserTypes.CHILD && fromUserType === UserTypes.CHILD ? FamilyMemberGroup.FAMILY_MEMBER_GROUP_SIBLINGS  : null;
            const subjectIsChild = fromUserType === UserTypes.CHILD;

            // Contributor
            const canBeContributor = subjectIsChild;

            // Editor
            // const fromCanBeEditor = UserRoleGroups.CAN_BE_EDITOR.includes(connectionUserType) && fromUserType === UserTypes.CHILD;
            // const toCanBeEditor = UserRoleGroups.CAN_BE_EDITOR.includes(fromUserType) && connectionUserType === UserTypes.CHILD;
            const canBeEditor = UserRoleGroups.CAN_BE_EDITOR.includes(connectionUserType) && fromUserType === UserTypes.CHILD; //fromCanBeEditor || toCanBeEditor;

            // Manager
            // const fromCanBeManager = UserRoleGroups.CAN_BE_MANAGER.includes(connectionUserType) && fromUserType === UserTypes.CHILD;
            // const toCanBeManager = UserRoleGroups.CAN_BE_MANAGER.includes(fromUserType) && connectionUserType === UserTypes.CHILD;
            const canBeManager = UserRoleGroups.CAN_BE_MANAGER.includes(connectionUserType) && fromUserType === UserTypes.CHILD; //fromCanBeManager || toCanBeManager;

            //Check if the connecting 'from' usertype can be a relation to the to person
            //LIF-1492 - connections can be set in both directions so if from or to is child show - don't show if to is adult
            const showFamilyDropdowns = (UserRoleGroups.CAN_BE_RELATION.includes(connectionUserType) && UserRoleGroups.CAN_BE_RELATION.includes(fromUserType)) && subjectIsChild;

            //Only display contact plans is the loggimg in user is a staff member and the selection is a usertype that can have a contact plan
            const loggedOnUserIsStaff = phpVars.user_type_group === UserGroupTypes.USER_GROUP_STAFF;
            const canHaveCommsPlan = (UserRoleGroups.CAN_HAVE_COMMS_PLAN.includes(connectionUserType)) && (UserRoleGroups.CAN_HAVE_COMMS_PLAN.includes(fromUserType));

            //Only display users created by the parent in dropdown when creating a new connection if not staff
            const myCreatedOnly  = !loggedOnUserIsStaff && props.mode === 'create' ? true : false;

            //Does organisation have lifestory configured
            const has_lifestory = phpVars.has_lifestory === 1 ? true : false;

            return (
                <Fragment>

                    <div className='buy-card-right'>
                        <div style={{marginBottom: '10px'}}>
                            { /* <ReactHookFormDropdownUserConnections name={'user_id'} user_id={props.from_user_id} onChange={onChangeDropdown} value={connectedUser} options={{isRawValue: true}} readOnly={dropDownReadOnly}/> */}
                        </div>

                        <form className='registration-form' onSubmit={handleSubmit(onSubmit)}>

                            <div className='row'>
                                {!myCreatedOnly && <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Connect User</label>
                                        <DropdownUserConnections readOnly={dropdownIsReadOnly} control={control}
                                                                 mode={props.mode} name='user.connected_user'
                                                                 rules={{required: true, validate: validateDropdown}}
                                                                 user_id={props.from_user_id}
                                                                 to_user_id ={props.user_id}
                                                                 placeholder='Please select User'
                                                                 teamFilter={props.team_id}
                                                                 isSearchable={true}/>
                                        {formErrors.user?.connected_user &&
                                            <ErrorDiv>{formErrors.user.connected_user.message}</ErrorDiv>}
                                    </div>
                                </div>}

                                {myCreatedOnly && <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Connect User</label>
                                        <DropdownMyContributors readOnly={dropdownIsReadOnly} control={control}
                                                                mode={props.mode} name='user.connected_user'
                                                                rules={{required: true, validate: validateDropdown}}
                                                                user_id={phpVars.user_id}
                                                                child_uid={data.data.idusers}
                                                                placeholder='Please select User'
                                                                isSearchable={true}/>
                                        {formErrors.user?.connected_user &&
                                            <ErrorDiv>{formErrors.user.connected_user.message}</ErrorDiv>}
                                    </div>
                                </div>}

                                <div className='col-md-6'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>{knownAsLabel}</label>
                                        <input readOnly={false} className='form-control' name='user.known_as'
                                               id='known_as' {...register("user.known_as")} />
                                        {formErrors.user?.known_as && <ErrorDiv>Please enter a known-as name</ErrorDiv>}
                                    </div>
                                </div>
                            </div>

                            {connectedUser.value !== 0 && <div>
                                    {(showFamilyDropdowns && !bothAreAdults) && <div className='row'>
                                        <div className='col-md-6'>
                                            <div style={{marginBottom: '10px'}}>
                                                <label>Family Type</label>
                                                <DropdownFamilyTypes readOnly={false} control={control}
                                                                     mode={props.mode} name='user.ur_family_type_id'
                                                                     rules={{required: true, validate: validateDropdown}}
                                                                     placeholder='Please select a family type'
                                                                     isSearchable={true}/>
                                                {formErrors.user?.ur_family_type_id &&
                                                    <ErrorDiv>{formErrors.user.ur_family_type_id.message}</ErrorDiv>}
                                            </div>
                                        </div>
                                        <div className='col-md-6'>
                                            <div style={{marginBottom: '10px'}}>
                                                <label>Relationship</label>
                                                <DropdownUserRelationTypes readOnly={false} control={control}
                                                                           mode={props.mode}
                                                                           name='user.ur_relation_type'
                                                                           relationshipType={genericRelationshipType}
                                                                           rules={{required: true, validate: validateDropdown}}
                                                                           placeholder='Please select a relation type'
                                                                           isSearchable={true}/>
                                                {formErrors.user?.ur_relation_type &&
                                                    <ErrorDiv>{formErrors.user.ur_relation_type.message}</ErrorDiv>}
                                            </div>

                                        </div>
                                    </div>}

                                    {canHaveCommsPlan && loggedOnUserIsStaff &&
                                        <div className='slider-group'>
                                            <label>Has a Communications Plan</label>
                                            <FormToggle readOnly={true} control={control} name='contact_plan.has_contact_plan'/>
                                            {formErrors.contact_plan?.has_contact_plan &&
                                                <ErrorDiv>{formErrors.contact_plan.has_contact_plan.message}</ErrorDiv>}
                                        </div>
                                    }

                                    {loggedOnUserIsStaff && hasContactPlan &&
                                        <div className='slider-group' >
                                            <label>Can send Letters/Cards</label>
                                            <FormToggle readOnly={hasContactPlan} control={control} name='contact_plan.is_mailer'/>
                                            {formErrors.contact_plan?.is_mailer &&
                                                <ErrorDiv>{formErrors.contact_plan.is_mailer.message}</ErrorDiv>}
                                        </div>
                                    }

                                    {loggedOnUserIsStaff && hasContactPlan &&
                                        <div className='slider-group'>
                                            <label>Via Letter Box</label>
                                            <FormToggle readOnly={hasContactPlan} control={control} name='contact_plan.is_letterbox_required'/>
                                            {formErrors.contact_plan?.is_letterbox_required && <ErrorDiv>{formErrors.contact_plan.is_letterbox_required.message}</ErrorDiv>}
                                        </div>
                                    }

                                    {canBeEditor && !bothAreAdults &&
                                        <div className='slider-group'>
                                            <label>Is Editor</label>
                                            <FormToggle readOnly={false} control={control} name='contact.is_editor'/>
                                            {formErrors.contact?.is_editor && <ErrorDiv>{formErrors.contact.is_editor.message}</ErrorDiv>}
                                        </div>}

                                    {canBeManager && !bothAreAdults &&
                                        <div className='slider-group'>
                                            <label>Is Manager</label>
                                            <FormToggle readOnly={false} control={control} name='contact.is_manager'/>
                                            {formErrors.contact?.is_manager && <ErrorDiv>{formErrors.contact.is_manager.message}</ErrorDiv>}
                                        </div>}

                                {canBeContributor && has_lifestory &&
                                    <div className='slider-group' >
                                        <label>Is Contributor</label>
                                        <FormToggle readOnly={false} control={control} name='contact.is_contributor'/>
                                        {formErrors.contact?.is_contributor && <ErrorDiv>{formErrors.contact.is_contributor.message}</ErrorDiv>}
                                    </div>
                                }

                                    <div className='slider-group'>
                                        <label>Can Message</label>
                                        <FormToggle readOnly={hasContactPlan} control={control} name='contact.is_messager'/>
                                        {formErrors.contact?.is_messager && <ErrorDiv>{formErrors.contact.is_messager.message}</ErrorDiv>}
                                    </div>

                                </div>}

                            {loggedOnUserIsStaff && <div className='row'>
                                <div className='col-md-12'>
                                    <div style={{marginBottom: '10px'}}>
                                        <label>Notes about this relationship</label>
                                        <textarea readOnly={false} className='form-control' name='user.relation_notes'
                                               id='known_as' {...register("user.relation_notes")} />
                                        {formErrors.user?.relation_notes && <ErrorDiv>Please enter notes</ErrorDiv>}
                                    </div>
                                </div>
                            </div>}
                        </form>
                    </div>

                    <div className="d-flex flex-row justify-content-end">
                        <button onClick={onClickCancel} className="btn btn-secondary">Cancel<i
                            className="et-arrow-bold-left"/></button>
                        <SaveButton state={buttonState} onClick={onClickSaveForm}
                                    label={getSaveButtonText(props.mode)}/>
                    </div>

                </Fragment>
            )
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper" width={'600px'} columns={2}>
            {title()}
            {formContent()}
        </ModalContentWrapper>
    )
}

export default ModalAddUserConnection;

ModalAddUserConnection.propTypes = {
    params: PropTypes.object,
    user_id: PropTypes.string,
};